/**
 * The real Bitbew mark and wordmark, applied as CSS masks that paint
 * currentColor, exactly as the site does (src/components/Logo.tsx explains
 * why). The SVGs are flat white artwork; never swap these for <img> tags or
 * redraw the mark.
 */

const MASK = {
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  maskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  WebkitMaskSize: 'contain',
} as const;

export function Mark({ className = '' }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`block shrink-0 bg-current ${className}`}
      style={{ ...MASK, maskImage: 'url("/logo/BitbewLight.svg")', WebkitMaskImage: 'url("/logo/BitbewLight.svg")' }}
    />
  );
}

export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`block shrink-0 bg-current ${className}`}
      style={{
        ...MASK,
        aspectRatio: '850 / 158',
        maskImage: 'url("/logo/BitbewTextWhite.svg")',
        WebkitMaskImage: 'url("/logo/BitbewTextWhite.svg")',
      }}
    />
  );
}
